// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&family=IBM+Plex+Mono:wght@400;500;600&family=IBM+Plex+Sans:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fx-root {
  --fx-ink: #101820;
  --fx-paper: #efe6d6;
  --fx-tag: #f7f1e6;
  --fx-line: #1c1915;
  --fx-muted: #5c5348;
  --fx-bug: #9f2d2d;
  --fx-issue: #8a5a12;
  --fx-improve: #0b6e62;
  --fx-display: "Bebas Neue", "Arial Narrow", Impact, sans-serif;
  --fx-sans: "IBM Plex Sans", "Segoe UI", sans-serif;
  --fx-mono: "IBM Plex Mono", ui-monospace, monospace;

  font-family: var(--fx-sans);
  color: var(--fx-ink);
  background:
    radial-gradient(520px 220px at 0% 0%, rgba(159, 45, 45, 0.08), transparent 70%),
    linear-gradient(180deg, #f3ecdf 0%, var(--fx-paper) 40%, #e7efe9 100%);
  min-height: calc(100vh - 72px);
  margin: -8px -12px 0;
  padding: 22px 18px 48px;
  box-sizing: border-box;
}

.fx-hero {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  align-items: flex-end;
  border-bottom: 2px solid var(--fx-line);
  padding-bottom: 14px;
  margin-bottom: 16px;
}

.fx-hero__eyebrow {
  margin: 0 0 4px;
  font-family: var(--fx-mono);
  font-size: 0.72rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--fx-improve);
}

.fx-hero__title {
  margin: 0;
  font-family: var(--fx-display);
  font-size: clamp(2.6rem, 6vw, 4rem);
  font-weight: 400;
  letter-spacing: 0.03em;
  line-height: 0.88;
}

.fx-hero__sub {
  margin: 8px 0 0;
  max-width: 38rem;
  color: var(--fx-muted);
  line-height: 1.45;
}

.fx-hero__sub code,
.fx-empty code {
  font-family: var(--fx-mono);
  font-size: 0.86em;
}

.fx-hero__count {
  margin: 0;
  text-align: right;
  font-family: var(--fx-mono);
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--fx-muted);
}

.fx-hero__count span {
  display: block;
  font-family: var(--fx-display);
  font-size: 3rem;
  letter-spacing: 0.02em;
  color: var(--fx-ink);
  line-height: 0.85;
}

.fx-filters {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
}

.fx-filters button:focus-visible,
.fx-actions button:focus-visible {
  outline: 2px solid var(--fx-improve);
  outline-offset: 2px;
}

.fx-filters button,
.fx-actions button {
  font-family: var(--fx-mono);
  font-size: 0.75rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border: 1px solid var(--fx-line);
  background: transparent;
  color: var(--fx-ink);
  padding: 6px 10px;
  cursor: pointer;
}

.fx-filters button.is-on,
.fx-actions button:hover {
  background: var(--fx-ink);
  color: #f7f1e6;
}

.fx-actions button.is-quiet:hover {
  background: transparent;
  color: var(--fx-bug);
  border-color: var(--fx-bug);
}

.fx-actions button:disabled {
  opacity: 0.5;
  cursor: wait;
}

.fx-error,
.fx-empty {
  font-family: var(--fx-mono);
  font-size: 0.86rem;
}

.fx-error {
  color: var(--fx-bug);
}

.fx-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 14px;
}

.fx-tag {
  display: grid;
  grid-template-columns: 28px 1fr;
  background: var(--fx-tag);
  border: 1px dashed var(--fx-line);
  box-shadow: 4px 4px 0 rgba(16, 24, 32, 0.08);
}

.fx-tag__punch {
  margin: 14px auto 0;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid var(--fx-line);
  background:
    radial-gradient(circle at 50% 50%, transparent 45%, var(--fx-line) 46% 58%, transparent 59%);
}

.fx-tag__body {
  padding: 12px 14px 12px 0;
}

.fx-tag__top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.fx-stamp {
  font-family: var(--fx-display);
  letter-spacing: 0.08em;
  font-size: 1.35rem;
  line-height: 1;
  border: 2px solid currentColor;
  padding: 2px 8px 0;
  transform: rotate(-2deg);
}

.fx-stamp.is-bug {
  color: var(--fx-bug);
}

.fx-stamp.is-issue {
  color: var(--fx-issue);
}

.fx-stamp.is-improvement {
  color: var(--fx-improve);
}

.fx-status,
.fx-id,
.fx-meta,
.fx-note,
.fx-sha {
  font-family: var(--fx-mono);
  font-size: 0.75rem;
}

.fx-status {
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.fx-status.is-deployed {
  color: var(--fx-improve);
}

.fx-status.is-failed {
  color: var(--fx-bug);
}

.fx-id {
  margin-left: auto;
  color: var(--fx-muted);
}

.fx-message {
  margin: 10px 0 6px;
  font-size: 1.02rem;
  line-height: 1.4;
  white-space: pre-wrap;
}

.fx-meta,
.fx-note,
.fx-sha {
  margin: 0;
  color: var(--fx-muted);
}

.fx-note {
  margin-top: 6px;
  color: var(--fx-ink);
}

.fx-actions {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

@media (max-width: 720px) {
  .fx-hero {
    flex-direction: column;
    align-items: flex-start;
  }

  .fx-hero__count {
    text-align: left;
  }

  .fx-id {
    margin-left: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .fx-stamp {
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/superadmin/FixcodeDesk.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,8DAA8D;EAC9D,kDAAkD;EAClD,mDAAmD;;EAEnD,2BAA2B;EAC3B,oBAAoB;EACpB;;0EAEwE;EACxE,8BAA8B;EAC9B,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,uCAAuC;EACvC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,yBAAyB;EACzB,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC;gGAC8F;AAChG;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;EAKE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Bebas+Neue&family=IBM+Plex+Mono:wght@400;500;600&family=IBM+Plex+Sans:wght@400;500;600;700&display=swap\");\n\n.fx-root {\n  --fx-ink: #101820;\n  --fx-paper: #efe6d6;\n  --fx-tag: #f7f1e6;\n  --fx-line: #1c1915;\n  --fx-muted: #5c5348;\n  --fx-bug: #9f2d2d;\n  --fx-issue: #8a5a12;\n  --fx-improve: #0b6e62;\n  --fx-display: \"Bebas Neue\", \"Arial Narrow\", Impact, sans-serif;\n  --fx-sans: \"IBM Plex Sans\", \"Segoe UI\", sans-serif;\n  --fx-mono: \"IBM Plex Mono\", ui-monospace, monospace;\n\n  font-family: var(--fx-sans);\n  color: var(--fx-ink);\n  background:\n    radial-gradient(520px 220px at 0% 0%, rgba(159, 45, 45, 0.08), transparent 70%),\n    linear-gradient(180deg, #f3ecdf 0%, var(--fx-paper) 40%, #e7efe9 100%);\n  min-height: calc(100vh - 72px);\n  margin: -8px -12px 0;\n  padding: 22px 18px 48px;\n  box-sizing: border-box;\n}\n\n.fx-hero {\n  display: flex;\n  justify-content: space-between;\n  gap: 18px;\n  align-items: flex-end;\n  border-bottom: 2px solid var(--fx-line);\n  padding-bottom: 14px;\n  margin-bottom: 16px;\n}\n\n.fx-hero__eyebrow {\n  margin: 0 0 4px;\n  font-family: var(--fx-mono);\n  font-size: 0.72rem;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--fx-improve);\n}\n\n.fx-hero__title {\n  margin: 0;\n  font-family: var(--fx-display);\n  font-size: clamp(2.6rem, 6vw, 4rem);\n  font-weight: 400;\n  letter-spacing: 0.03em;\n  line-height: 0.88;\n}\n\n.fx-hero__sub {\n  margin: 8px 0 0;\n  max-width: 38rem;\n  color: var(--fx-muted);\n  line-height: 1.45;\n}\n\n.fx-hero__sub code,\n.fx-empty code {\n  font-family: var(--fx-mono);\n  font-size: 0.86em;\n}\n\n.fx-hero__count {\n  margin: 0;\n  text-align: right;\n  font-family: var(--fx-mono);\n  font-size: 0.75rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--fx-muted);\n}\n\n.fx-hero__count span {\n  display: block;\n  font-family: var(--fx-display);\n  font-size: 3rem;\n  letter-spacing: 0.02em;\n  color: var(--fx-ink);\n  line-height: 0.85;\n}\n\n.fx-filters {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n\n.fx-filters button:focus-visible,\n.fx-actions button:focus-visible {\n  outline: 2px solid var(--fx-improve);\n  outline-offset: 2px;\n}\n\n.fx-filters button,\n.fx-actions button {\n  font-family: var(--fx-mono);\n  font-size: 0.75rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  border: 1px solid var(--fx-line);\n  background: transparent;\n  color: var(--fx-ink);\n  padding: 6px 10px;\n  cursor: pointer;\n}\n\n.fx-filters button.is-on,\n.fx-actions button:hover {\n  background: var(--fx-ink);\n  color: #f7f1e6;\n}\n\n.fx-actions button.is-quiet:hover {\n  background: transparent;\n  color: var(--fx-bug);\n  border-color: var(--fx-bug);\n}\n\n.fx-actions button:disabled {\n  opacity: 0.5;\n  cursor: wait;\n}\n\n.fx-error,\n.fx-empty {\n  font-family: var(--fx-mono);\n  font-size: 0.86rem;\n}\n\n.fx-error {\n  color: var(--fx-bug);\n}\n\n.fx-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 14px;\n}\n\n.fx-tag {\n  display: grid;\n  grid-template-columns: 28px 1fr;\n  background: var(--fx-tag);\n  border: 1px dashed var(--fx-line);\n  box-shadow: 4px 4px 0 rgba(16, 24, 32, 0.08);\n}\n\n.fx-tag__punch {\n  margin: 14px auto 0;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 2px solid var(--fx-line);\n  background:\n    radial-gradient(circle at 50% 50%, transparent 45%, var(--fx-line) 46% 58%, transparent 59%);\n}\n\n.fx-tag__body {\n  padding: 12px 14px 12px 0;\n}\n\n.fx-tag__top {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.fx-stamp {\n  font-family: var(--fx-display);\n  letter-spacing: 0.08em;\n  font-size: 1.35rem;\n  line-height: 1;\n  border: 2px solid currentColor;\n  padding: 2px 8px 0;\n  transform: rotate(-2deg);\n}\n\n.fx-stamp.is-bug {\n  color: var(--fx-bug);\n}\n\n.fx-stamp.is-issue {\n  color: var(--fx-issue);\n}\n\n.fx-stamp.is-improvement {\n  color: var(--fx-improve);\n}\n\n.fx-status,\n.fx-id,\n.fx-meta,\n.fx-note,\n.fx-sha {\n  font-family: var(--fx-mono);\n  font-size: 0.75rem;\n}\n\n.fx-status {\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.fx-status.is-deployed {\n  color: var(--fx-improve);\n}\n\n.fx-status.is-failed {\n  color: var(--fx-bug);\n}\n\n.fx-id {\n  margin-left: auto;\n  color: var(--fx-muted);\n}\n\n.fx-message {\n  margin: 10px 0 6px;\n  font-size: 1.02rem;\n  line-height: 1.4;\n  white-space: pre-wrap;\n}\n\n.fx-meta,\n.fx-note,\n.fx-sha {\n  margin: 0;\n  color: var(--fx-muted);\n}\n\n.fx-note {\n  margin-top: 6px;\n  color: var(--fx-ink);\n}\n\n.fx-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n@media (max-width: 720px) {\n  .fx-hero {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .fx-hero__count {\n    text-align: left;\n  }\n\n  .fx-id {\n    margin-left: 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fx-stamp {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
